import { AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Card } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";
import { AccordionHeader } from "../AccordionHeader";
import { EventDetailsAccordionHeader } from "@/components/event-details/accordion/EventDetailsAccordionHeader";
import { cn } from "@/lib/utils";
interface AccordionSectionProps {
  value: string;
  title: string;
  subtitle?: string;
  icon: LucideIcon;
  isValid: boolean;
  hasError?: boolean;
  extraContent?: React.ReactNode;
  children: React.ReactNode;
  useDetailsHeader?: boolean;
}
export const AccordionSection = ({
  value,
  title,
  subtitle,
  icon,
  isValid,
  hasError,
  extraContent,
  children,
  useDetailsHeader = false
}: AccordionSectionProps) => {
  return <AccordionItem value={value} className={cn("border rounded-lg mb-4 overflow-hidden bg-[#F5F5F5]", hasError && "border-destructive")}>
      <Card className="py-0 px-6 bg-white shadow-xl">
        <AccordionTrigger className="text-xl font-semibold text-left [&>svg]:ml-4">
          {useDetailsHeader ? <EventDetailsAccordionHeader icon={icon} title={title} subtitle={subtitle} extraContent={extraContent} /> : <AccordionHeader icon={icon} title={title} subtitle={subtitle} isValid={isValid} extraContent={extraContent} />}
        </AccordionTrigger>
        <AccordionContent className="pt-0">
          {children}
        </AccordionContent>
      </Card>
    </AccordionItem>;
};